// --- News category filter ---

//import axios from 'axios';
//const axios = require('axios/dist/browser/axios.cjs');

/* const categories = document.querySelectorAll('[data-func="categories"] .custom-menu .custom-nav .custom-link');
const wrapper = document.querySelector('[data-func="categories"] [data-results]');

if(categories) {
    categories.forEach(category => category.addEventListener('click', function(e) {
        e.preventDefault();

        let slug = this.dataset.slug;
        let formData = new FormData;

        formData.append('action', 'filter_news');
        formData.append('category', slug);

        removeActive(categories);

        this.parentElement.classList.add('active');

        wrapper.style.opacity = 0;

        axios.post('./wp-admin/admin-ajax.php', formData).then(function(response) {
            wrapper.innerHTML = response.data;
            wrapper.style.opacity = 1;
        });
    }));
}

function removeActive(categories) {
    categories.forEach(element => {
        element.parentElement.classList.remove('active');
    });
} */

const categories = document.querySelectorAll('[data-func="categories"] .custom-menu .custom-nav .custom-link');
const types = document.querySelectorAll('input[name="type"]');
const wrapper = document.querySelector('[data-func="categories"] [data-results]');

function filterResults(element, slug, wrapper) {
    let formData = new FormData;
    let action = wrapper.dataset.action ?? 'filter_news';
    let count = wrapper.dataset.count;
    /* let typeSelect = ['Prodej', 'Pronájem']; */

    formData.append('action', action);
    formData.append('category', slug);
    formData.append('count', count);

    removeActive(categories);

    element.parentElement.classList.add('active');

    wrapper.style.opacity = 0;

    axios.post('/wp-admin/admin-ajax.php', formData).then(function (response) {
        wrapper.innerHTML = response.data;
        wrapper.style.opacity = 1;

        const mountSwiperKatalogArchive = new Swiper('.swiper-katalog', swiperSettingsKatalogArchive);
    });
}

if(categories) {
    categories.forEach(category => category.addEventListener('click', function(e) {
        e.preventDefault();

        filterResults(this, this.dataset.slug, wrapper);
    }));
}

function removeActive(categories) {
    categories.forEach(element => {
        element.parentElement.classList.remove('active');
    });
}